// Burger Builder
export const ADD_INGREDIENTS='ADD_INGREDIENTS';
export const REM_INGREDIENTS='REM_INGREDIENTS';
export const DEF_INGREDIENTS='DEF_INGREDIENTS';
export const DEF_INGREDIENTS_FAILED='DEF_INGREDIENTS_FAILED';
//Order
export const PURCHASE_INIT='PURCHASE_INIT';
export const PURCHASE_BURGER_START ='PURCHASE_BURGER_START';
export const PURCHASE_BURGER_SUCCESS='PURCHASE_BURGER_SUCCESS';
export const PURCHASE_BURGER_FAILED ='PURCHASE_BURGER_FAILED';

export const FETCH_ORDERS_START ='FETCH_ORDERS_START';
export const FETCH_ORDERS_SUCCESS ='FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAILED ='FETCH_ORDERS_FAILED';

//Auth
export const AUTH_START='AUTH_START';
export const AUTH_SUCCESS='AUTH_SUCCESS';
export const AUTH_FAIL='AUTH_FAIL';
export const AUTH_LOGOUT='AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH ='SET_AUTH_REDIRECT_PATH';